import ThesisChangesCardWrapper from './ThesisChangesCardWrapper'

export * from './ThesisChangesCard'

export default ThesisChangesCardWrapper
